import { render, staticRenderFns } from "./SideBarNav.vue?vue&type=template&id=2129c51a&"
import script from "./SideBarNav.vue?vue&type=script&lang=js&"
export * from "./SideBarNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports